
import './Home.css';
import Content from '../components/Content';

import vendly from '../assets/logos/vendly.svg'
import vendos from '../assets/logos/vendos.svg'
import osko from '../assets/logos/osko.svg'

import LandingVideo from '../assets/Landing5.webm';
function HomePage() {

  return (
    <div>
      <Hero />
      <WhatWeDo />
      <Evolved />
      {/* <BottomBlur /> */}
    </div>

  );
}


function Hero() {
  return (
    <div className="relative min-h-screen overflow-hidden">
      <video
        className="absolute top-0 left-0 w-full h-full object-cover"
        src={LandingVideo}
        autoPlay
        loop
        muted
        playsInline
      />

      <div className="relative z-20 min-h-screen flex flex-col justify-end">
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12 text-center">
          <p className="text-2xl text-white/80">
            "Any sufficiently advanced technology is indistinguishable from magic."
          </p>
          <p className="text-sm text-white/60 mt-2 font-mono">
            Arthur C. Clarke's Third Law
          </p>
        </div>
      </div>
    </div>
  );
}


function WhatWeDo() {
  return (
    <Content bgColor='bg-black'>


      <div className="col-span-12 md:col-span-5 flex justify-center md:justify-start">
        <h2 className="text-lg text-customGray">What we do</h2>
      </div>
      <div className="col-span-12 md:col-span-7">
        <p className="text-xl text-white text-justify">
          White-label creative technology for agencies who want things done properly. We specialize in custom kiosks and vending hardware, but we're happy to tackle any ambitious tech brief.
        </p>
        <p className="text-xl text-customGray text-justify pt-16">
          Software is written from scratch, hardware is designed in-house, and manufacturing is handled with us from start to finish.
        </p>
      </div>

    </Content>
  )
}

function Evolved() {
  return (
    <Content bgColor='bg-customCharcoal'>
      <div className="col-span-12 md:col-span-5 flex justify-center md:justify-start pb-24">
        <h2 className="text-lg text-customGray">Companies</h2>
      </div>

      <div className="col-span-12 grid grid-cols-1 gap-24 pt-8 md:col-span-7 md:col-start-6 md:grid-cols-2">
        <div className="flex flex-col gap-12">
          <a href='https://vendly.xyz'><img src={vendly} alt="Vendly" className="h-8 w-auto object-contain object-left" /></a>
          <p className="text-sm text-white text-justify">
            Where it all started. Smart vending for brand activations and experiential marketing.
            <br />
            <br />
            <i className='text-customGray'>Formerly <a href='https://socialvend.com'>Social Vend</a> & <a  href='https://machineco.io'>MachineCo</a>.</i>
          </p>
        </div>

        <div className="flex flex-col gap-12">
          <a href='https://vendos.io'><img src={vendos} alt="vendOS" className="h-8 w-auto object-contain object-left" /></a>
          <p className="text-sm text-white text-justify">
            The operating system and cloud platform behind our vending deployments. Proven in the field, available standalone.
          </p>
        </div>

        <div className="flex flex-col gap-12">
          <img src={osko} alt="Osko" className="h-8 w-auto object-contain object-left" />
          <p className="text-sm text-white text-justify">
            Custom kiosk design and manufacturing for in-store retail.
            <span className="text-customGray ml-1">Under development.</span>
          </p>
        </div>
      </div>
    </Content>
  )
}

// function BottomBlur() {
//   return (
//     <div
//       className="fixed bottom-0 left-0 right-0 h-36 backdrop-blur-md pointer-events-none z-30"
//       style={{
//         maskImage: 'linear-gradient(to top, black 50%, transparent 100%)',
//         WebkitMaskImage: 'linear-gradient(to top, black 50%, transparent 100%)'
//       }}
//     ></div>
//   );
// }
// function BottomBlur() {
//   const [offset, setOffset] = useState(0);

//   useEffect(() => {
//     const handleScroll = () => {
//       const scrollPosition = window.scrollY + window.innerHeight;
//       const pageHeight = document.documentElement.scrollHeight;

//       // Only move when overscrolling past the bottom
//       if (scrollPosition > pageHeight) {
//         setOffset(scrollPosition - pageHeight);
//       } else {
//         setOffset(0);
//       }
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   return (
//     <div
//       className="fixed left-0 right-0 h-[30vh] pointer-events-none z-40"
//       style={{ bottom: `-${offset}px` }}
//     >
//       <div
//         className="absolute inset-0 backdrop-blur-[1px]"
//         style={{
//           maskImage: 'linear-gradient(to bottom, transparent 0%, black 16.67%)',
//           WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, black 16.67%)'
//         }}
//       ></div>
//       <div
//         className="absolute inset-0 backdrop-blur-[2px]"
//         style={{
//           maskImage: 'linear-gradient(to bottom, transparent 16.67%, black 33.33%)',
//           WebkitMaskImage: 'linear-gradient(to bottom, transparent 16.67%, black 33.33%)'
//         }}
//       ></div>
//       <div
//         className="absolute inset-0 backdrop-blur-[4px]"
//         style={{
//           maskImage: 'linear-gradient(to bottom, transparent 33.33%, black 50%)',
//           WebkitMaskImage: 'linear-gradient(to bottom, transparent 33.33%, black 50%)'
//         }}
//       ></div>
//       <div
//         className="absolute inset-0 backdrop-blur-[8px]"
//         style={{
//           maskImage: 'linear-gradient(to bottom, transparent 50%, black 66.67%)',
//           WebkitMaskImage: 'linear-gradient(to bottom, transparent 50%, black 66.67%)'
//         }}
//       ></div>
//       <div
//         className="absolute inset-0 backdrop-blur-[16px]"
//         style={{
//           maskImage: 'linear-gradient(to bottom, transparent 66.67%, black 83.33%)',
//           WebkitMaskImage: 'linear-gradient(to bottom, transparent 66.67%, black 83.33%)'
//         }}
//       ></div>
//       <div
//         className="absolute inset-0 backdrop-blur-[32px]"
//         style={{
//           maskImage: 'linear-gradient(to bottom, transparent 83.33%, black 100%)',
//           WebkitMaskImage: 'linear-gradient(to bottom, transparent 83.33%, black 100%)'
//         }}
//       ></div>
//     </div>
//   );
// }

// export default BottomBlur;

export default HomePage;
